// extracted by mini-css-extract-plugin
module.exports = {"textHeader":"zoo-module--textHeader--ZWGeD","projectImage":"zoo-module--projectImage--Wz1mK"};